import Cards from 'react-credit-cards';
import { AbconetApi } from "./AbconetApi";
import Select, { components } from 'react-select';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const SingleValue = props => {
    return <components.SingleValue {...props}>
        <span className="cc-option"><img src={"/Content/Images/cc-" + props.data.brand + ".svg"} /> ending with {props.data.last4}</span>
    </components.SingleValue>;
}


export class CreditCardSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            creditCard: {
                name: "",
                number: "",
                year: "",
                month: "",
                cvv: "",
                isValid: false
            },
            selectedCard: this.props.initCard,
            tokenCollection: [],
            addNewOpen: false,
            isLoading: true,
            errorMessage: null,
            deleteErrorMessage: null,
            addingCreditCard: false
        };
    }

    componentDidMount() {
        this.refreshTokenData();
    }

    refreshTokenData() {
        AbconetApi.get('/api/user/paymentToken').then(data => {
            if (data.length > 0 && this.props.initCard == null) {
                this.setSelectedCard(data[0]);
            }

            this.setState({
                tokenCollection: data,
                isLoading: false
            });
        });
    }

    setSelectedCard(cardData) {
        this.setState({
            selectedCard: cardData
        });

        this.props.onChange(cardData);
    }

    handleInputFocus({ target }) {
        this.setState({
            focused: target.name
        });
    }

    updateCreditCard(field, ev) {
        var creditCard = this.state.creditCard;
        creditCard[field] = ev.target.value;
        this.setState({ creditCard: creditCard });
    }

    checkCreditCard(creditCardInfo, isValid) {
        var creditCard = this.state.creditCard;
        creditCard.isValid = isValid;

        this.setState({ creditCard: creditCard }, this.triggerChange);
    }

    addCreditCard(ev) {
        ev.preventDefault();
        this.setState({
            addingCreditCard: true
        });
        AbconetApi.post('/api/user/paymentToken', this.state.creditCard, null,true).then((token) => {
            this.setState({
                addingCreditCard: false
            });

            this.setSelectedCard(token);
            this.closeAddNew();
            this.refreshTokenData();
               
        }).catch((error) => {
            this.setState({
                addingCreditCard: false
            });

            this.setState({
                errorMessage: error.message
            });
        });
    }

    closeAddNew(ev) {
        if (ev) {
            ev.preventDefault();
        }
            
        this.setState({ addNewOpen: false });
    }

    openAddNew() {
        this.setState({ addNewOpen: true });
    }

    renderAlertMessage() {
        if (this.state.errorMessage != null) {
            return <div className={`alert alert-danger`} role="alert">
                       {this.state.errorMessage}
                   </div>;
        }
        return null;
    }

    renderDeleteErrorMessage() {
        if (this.state.deleteErrorMessage != null) {
            return <div className={`alert alert-danger`} role="alert">
                {this.state.deleteErrorMessage}
                   </div>;
        }
        return null;
    }

    renderAddCreditButton() {
        var btnText = 'Add';
        var btnClass = '';


        if (this.state.addingCreditCard) {
            btnText = 'Adding';
            btnClass = 'saving';
        }

        return <button className={"btn btn-secondary ml-2 " + btnClass} disabled={this.state.addingCreditCard}>{btnText}</button>;
    }

    renderAddNewCreditCard() {
        return <div className="row">
                <div className="col-6 align-self-center">
                <Cards 
                        number={this.state.creditCard.number}
                        name={this.state.creditCard.name}
                        expiry={this.state.creditCard.month + this.state.creditCard.year}
                        placeholders={{ name: "Pete's Card" }}
                        cvc={this.state.creditCard.cvv}
                        callback={this.checkCreditCard.bind(this)}
                        focused={this.state.focused} />
                </div>
                <div className="col-6">
                    <form className="container credit-card-form" onSubmit={this.addCreditCard.bind(this)}>
                        <div className="row">
                            <div className="col-12">
                                <label>Name on card</label>
                                <input type="text" className="form-control" name="name" placeholder="Pete" onFocus={this.handleInputFocus.bind(this)} onChange={this.updateCreditCard.bind(this, "name")} required="" />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-12">
                                <label>Card Number</label>
                                <input type="tel" name="number" className="form-control" placeholder="" onFocus={this.handleInputFocus.bind(this)} onChange={this.updateCreditCard.bind(this, "number")} required="" />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-md-4 mb-3">
                                <label>Month</label>
                                <select className="form-control" name="expiry" onFocus={this
                                    .handleInputFocus
                                    .bind(this)} onChange={this.updateCreditCard.bind(this, "month")}>
                                    <option></option>
                                    <option value="01">1</option>
                                    <option value="02">2</option>
                                    <option value="03">3</option>
                                    <option value="04">4</option>
                                    <option value="05">5</option>
                                    <option value="06">6</option>
                                    <option value="07">7</option>
                                    <option value="08">8</option>
                                    <option value="09">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                </select>
                                <div className="invalid-feedback">Please provide a valid month.</div>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label>Year</label>
                                <select className="form-control" name="expiry" onFocus={this
                                    .handleInputFocus
                                    .bind(this)} onChange={this.updateCreditCard.bind(this, "year")}>
                                    <option value="23">2023</option>
                                    <option value="24">2024</option>
                                    <option value="25">2025</option>
                                    <option value="26">2026</option>
                                    <option value="27">2027</option>
                                    <option value="28">2028</option>
                                    <option value="29">2029</option>
                                    <option value="30">2030</option> 
                                    
                                </select>
                                <div className="invalid-feedback">Please provide a valid state.</div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <label>CVV</label>
                                <input type="text" className="form-control" name="cvc" placeholder="xxx" required="" onFocus={this.handleInputFocus.bind(this)} onChange={this.updateCreditCard.bind(this, "cvv")} />
                                <div className="invalid-feedback">Please provide a valid cvc.</div>
                            </div>
                    </div>
                    {this.renderAlertMessage()}
                        <button className="btn btn-outline-secondary" onClick={this.closeAddNew.bind(this)}>Cancel</button>
                    {this.renderAddCreditButton()}
                    
                </form>

                </div>
                   </div>;
 
    }

    promptDelete(creditCard) {

        this.setState({ deleteCard: creditCard });
    }

    clearDeleteCard() {
        this.setState({ deleteCard: null });
    }

    confirmDeleteCard() {
        AbconetApi.post('/api/user/deletePaymentToken', this.state.deleteCard, null, true).then((token) => {
            this.setState({
                deleteCard: null,
                deleteErrorMessage: null
            });

            this.refreshTokenData();

        }).catch((error) => {
            this.setState({
                deleteCard: null
            });

            this.setState({
                deleteErrorMessage: "Error deleting card: " + error.message
        });
        });
        this.setState({ deleteCard: null });
    }

    render() {
        if (this.state.isLoading) {
            return null;
        }

        if (this.state.deleteCard != null) {
            return <div>
                <div className="mb-3">Are you sure you want to remove {this.state.deleteCard.brand} ending {this.state.deleteCard.last4}</div>
                <button type="button" className="btn btn-outline-primary" onClick={this.clearDeleteCard.bind(this)}>No, Keep Card</button> <button type="button" className="btn btn-danger" onClick={this.confirmDeleteCard.bind(this)}>Yes, Delete Card</button>
            </div>;
        }

        if (this.state.addNewOpen || this.state.tokenCollection == null || this.state.tokenCollection.length === 0 ) {
            return this.renderAddNewCreditCard();
        } else {
                return (
                    <div className="row">
                        <div className="col-12">{this.renderDeleteErrorMessage()}</div>
                       

                       <div className="col-1"></div>
                        <div className="col-5">
                            <Select className="select-inline type-month"
                                value={this.state.selectedCard}
                                onChange={this.setSelectedCard.bind(this)}
                                components={{ SingleValue }}
                                getOptionLabel={(option) => <span className="cc-option"><img src={"/Content/Images/cc-" + option.brand + ".svg"} /> ending with {option.last4} <i className="icon icon-trash lead" onClick={this.promptDelete.bind(this, option)}></i></span>}
                                    getOptionValue={(option) => option.id}
                                    options={this.state.tokenCollection}/>
                        </div>
                        <div className="col-2 text-center">or</div>
                        <div className="col-4">
                            <button className="btn btn-outline-secondary" onClick={this.openAddNew.bind(this)}>Add New</button>
                        </div>
                   </div>);
        }
    }
}


export class PaymentOption extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            paymentType: props.cart.paymentOption,
            creditCard: props.cart.paymentToken
        };
    }
    

    setPaymentType(index) {
        var paymentType = "CREDITCARD";

        if (index == 0 && this.props.cart.hasAccountTerms) {
            paymentType = "ACCOUNT";
        }
        

        this.setState({
            paymentType: paymentType
        }, this.triggerChange);
    }

    triggerChange() {

        this.props.onChange({
            paymentType: this.state.paymentType,
            creditCard: this.state.creditCard
        });
    }

    handleCreditCardChange(creditCard) {
        this.setState({
            creditCard: creditCard
        }, this.triggerChange);
    }

    renderCreditAlert() {
        if (this.props.cart.creditStatus == "WILL_BE_OVER") {
            return <div className="alert alert-danger">This order will put you over your credit terms. This may affect delivery of this order.</div>;
        }
    }

    render() {
        var defaultIndex;
        if (this.props.cart.hasAccountTerms && this.props.cart.paymentOption == "CREDITCARD") {
            defaultIndex = 1;
        }
        return (
            <Tabs className="icon-tabs" onSelect={this.setPaymentType.bind(this)} defaultIndex={defaultIndex}>
                <TabList>
                    {this.props.cart.hasAccountTerms && <Tab><i className="icon icon-debtor-account lead"></i>Account</Tab>}
                    <Tab><i className="icon icon-credit-card lead"></i>Credit Card</Tab>
                </TabList>
                {this.props.cart.hasAccountTerms && <TabPanel>
                    <div>Payment by account terms.</div>
                    {this.renderCreditAlert()}
                </TabPanel>}
                <TabPanel>
                    <CreditCardSelector onChange={this.handleCreditCardChange.bind(this)} initCard={this.props.cart.paymentToken} />
                </TabPanel>
            </Tabs>
        );
    }
}